import React, { Component } from "react";

class About extends Component {
  render() {
    return (
      <div>
        <h3>Christopher Nolan</h3>
        <p>
          Christopher Edward Nolan CBE (/ˈnoʊlən/; born 30 July 1970) is a
          British-American film director, producer, and screenwriter. His
          directorial efforts have grossed more than US$5 billion worldwide,
          garnered 36 Oscar nominations and 11 wins. Born and raised in London,
          Nolan developed an interest in filmmaking from a young age. After
          studying English literature at University College London, he made his
          feature debut with Following (1998). Nolan gained international
          recognition with his second film, Memento (2000), for which he was
          nominated for the Academy Award for Best Original Screenplay. He
          transitioned from independent to studio filmmaking with Insomnia
          (2002), and found further critical and commercial success with The
          Dark Knight Trilogy (2005–2012), The Prestige (2006), and Inception
          (2010), which received eight Oscar nominations, including for Best
          Picture and Best Original Screenplay. This was followed by
          Interstellar (2014), Dunkirk (2017), and Tenet (2020). He earned
          Academy Award nominations for Best Picture and Best Director for his
          work on Dunkirk.
        </p>
        <p>
          Nolan's films are typically rooted in epistemological and metaphysical
          themes, exploring human morality, the construction of time, and the
          malleable nature of memory and personal identity. His work is
          permeated by mathematically inspired images and concepts,
          unconventional narrative structures, practical special effects,
          experimental soundscapes, large-format film photography, and
          materialistic perspectives. He has co-written several of his films
          with his brother Jonathan, and runs the production company Syncopy
          Inc. with his wife Emma Thomas. Nolan has received many awards and
          honours. Time named him one of the 100 most influential people in the
          world in 2015, and in 2019, he was appointed Commander of the Order of
          the British Empire for his services to film.
        </p>
        <h3>Early life</h3>
        <p>
          Nolan was born in Westminster, London, and grew up in Highgate.[1][2]
          His father, Brendan James Nolan, was a British advertising executive
          who worked as a creative director.[3] His mother, Christina (née
          Jensen), was an American flight attendant who would later work as an
          English teacher.[3][4][5] Nolan's childhood was split between London
          and Evanston, Illinois, and he has both British and US
          citizenship.[6][7][8] He has an elder brother, Matthew,[9] and a
          younger brother, Jonathan, also a filmmaker.[10] Growing up, Nolan was
          particularly influenced by the work of Ridley Scott, and the science
          fiction films 2001: A Space Odyssey (1968) and Star Wars
          (1977).[11][12]
        </p>
        <p>
          Nolan was educated at Haileybury and Imperial Service College, an
          independent school in Hertford Heath, Hertfordshire, and later read
          English literature at University College London (UCL). Opting out of a
          traditional film education, he pursued "a degree in something
          unrelated ... because it gives a different take on things."[24] He
          chose UCL specifically for its filmmaking facilities, which comprised
          a Steenbeck editing suite and 16 mm film cameras.[25] Nolan was
          president of the Union's Film Society,[25] and with Emma Thomas (his
          girlfriend and future wife) he screened 35 mm feature films during the
          school year and used the money earned to produce 16 mm films over the
          summers.[26]
        </p>
        {/* <Link to="/home">home</Link> */}
      </div>
    );
  }
}

export default About;
